<kendo-pdfviewer style="height: 11n;" [url]="invoicePdfUrl" class="mt-10" [zoom]="1"> </kendo-pdfviewer>

<div class="k-form-buttons col-12 px-3 m-0 mb-3 d-flex justify-content-end mt-8">
  <button (click)="finish()" type="button" kendoButton themeColor="primary" class="btn btn-light-primary btn-form">
    <span class="btn-label">Finish</span>&nbsp;
    <span class="fa-light fa-angle-right me-2"></span>
  </button>
</div>  